import Flickity from 'flickity'
import 'flickity/css/flickity.css'
require('flickity-as-nav-for')
export function carrousel_thumb () {
  const carr1 = document.querySelector('.carrousel_thumb1')
  const carr2 = document.querySelector('.carrousel_thumb2')

  if (carr1) {
    console.log('entramos')
    const flktyTH1 = new Flickity(carr1, {
      cellAlign: 'center',
      contain: true,
      wrapAround: true,
      autoPlay: true,
      pauseAutoPlayOnHover: false,
      dragThreshold: 10,
      selectedAttraction: 0.2,
      friction: 0.8,
      pageDots: false,
      adaptiveHeight: true

    })

    const flktyTH2 = new Flickity(carr2, {
      cellAlign: 'center',
      asNavFor: '.carrousel_thumb1',
      contain: true,
      wrapAround: false,
      autoPlay: true,
      pauseAutoPlayOnHover: false,
      dragThreshold: 10,
      selectedAttraction: 0.2,
      friction: 0.8,
      pageDots: false,
      prevNextButtons: false,
      adaptiveHeight: true
    })
  }
}
carrousel_thumb()
// import { carrousel_thumb } from '@/js/shared/carrousels/carrousel_thumb'
